import { Flex, Layout } from 'antd';
import { ReactNode } from 'react';
import styles from './section.layout.module.scss';
import SectionWrapper from '@/components/section-wrapper/section-wrapper';
import clsx from 'clsx';

interface SectionLayoutProps {
  children: ReactNode;
  sectionTitle: string;
  sectionLink?: string;
  className?: string;
  flexClassName?: string;
}

export default function SectionLayout({
  children,
  sectionTitle,
  sectionLink,
  className,
  flexClassName,
}: SectionLayoutProps) {
  return (
    <Layout className={clsx(className, styles.sectionLayout)}>
      <SectionWrapper title={sectionTitle} link={sectionLink} />
      <Flex className={clsx(flexClassName, styles.sectionLayoutChartsContainer)}>{children}</Flex>
    </Layout>
  );
}
